import React from 'react';
import {observer, inject} from "mobx-react";
import {Modal, Button} from "react-bootstrap";

@inject("validationModal", "formStore") @observer
class ValidationErrorModal extends React.Component {

    render() {
        const s = this.props.validationModal;
        const f = this.props.formStore;

        const destMsg = (!f.selectedDestination) ? <div className="alert alert-warning" role="alert">
                נא לבחור יעד
        </div> : "";

        const visaErr = (f.selectedDestination && f.selectedDestination.c === 'DXB' && f.needDubaiVisa === null);

        const visaMsg = (visaErr) ? <div className="alert alert-warning" role="alert">
            נא לבחור אם אתם מעוניינים לרכוש ויזה לדובאי
        </div> : "";

        return (
            <Modal
                show={s.isOpen}
                onHide={() => {s.closeModal()}}
                backdrop="static"
            >
                <Modal.Header closeButton>
                    <Modal.Title />
                </Modal.Header>
                <Modal.Body>
                    <div className="alert alert-warning" role="alert">
                        אנא מלאו את הפרטים. כל השדות הנם שדות חובה
                    </div>
                    {destMsg}
                    {visaMsg}
                </Modal.Body>
                <Modal.Footer>
                    <Button
                        variant="primary"
                        onClick={() => {s.closeModal()}}
                    >
                        אישור
                    </Button>
                </Modal.Footer>
            </Modal>
        )
    }
}

export {ValidationErrorModal}